import { put } from "redux-saga/effects";
import { ExperiencesShopOptionResponse } from "redmond";

import { actions } from "../actions";
import { fetchExperienceShopOptions } from "../../../api/v0/shop/fetchExperiencesShopOptions";
import Logger from "../../../utils/logger";

/**
 * Iterates through candidate dates (from the shop response's bookableItems)
 * and fires a shop option request on each until one returns real availability.
 * The shop response's date list can be stale/sold out, so we verify by calling
 * the option endpoint rather than trusting the dates directly.
 */
export function* findNextAvailableDateSaga(
  action: actions.IFindNextAvailableDate,
) {
  const { candidateDates, request } = action;

  try {
    for (const date of candidateDates) {
      try {
        const response: ExperiencesShopOptionResponse =
          yield fetchExperienceShopOptions({ ...request, date });

        if (response.breakdowns.length > 0) {
          yield put(actions.setNextAvailableDate(date));
          return;
        }
      } catch (e) {
        // Individual date probe failed — skip and try the next one
        Logger.debug(e);
      }
    }

    // No available date found among candidates
    yield put(actions.setNextAvailableDate(null));
  } catch (e) {
    Logger.debug(e);
    yield put(actions.setNextAvailableDate(null));
  }
}
